/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * 角色功能對應檔 資料格式
 */
export interface RolePrivilegeMapping { 
    /**
     * 角色權限對應資料ID
     */
    rolePrivilegeMappingId?: number;
    /**
     * 角色資料ID
     */
    roleId?: number;
    /**
     * 功能權資料ID
     */
    functionPrivilegeId?: number;
}